<ul class="list-group">
	{{#searchTypes}}
		<li class="list-group-item {{active}}"><a id="myBids_{{id}}" class="x-search-filter" data-filter="{{id}}" href="#">{{{label}}}</a></li>
	{{/searchTypes}}
</ul>

